import axios, { AxiosRequestConfig } from 'axios';
import { decamelizeKeys } from 'humps';

const axiosInstance = axios.create({
  baseURL: "https://h0zbedftji.execute-api.us-east-1.amazonaws.com/staging",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
  const newConfig = { ...config };
  if (newConfig.headers['Content-Type'] === 'multipart/form-data')
    return newConfig;
  if (config.data) {
    newConfig.data = decamelizeKeys(config.data);
  }
  return newConfig;
});


export default axiosInstance;